export default __webpack_public_path__ + "296fb9e82d83c6fa1ffaced1c8d5d821.png";